import React from 'react';

import PageIcon from '@atlaskit/icon/core/page';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import DatabaseIcon from '@atlaskit/icon/core/database';
import FolderOpenIcon from '@atlaskit/icon/core/folder-open';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import AiGenerativeSlidesIcon from '@atlaskit/icon-lab/core/ai-generative-slides';
import PageLiveDocIcon from '@atlaskit/icon-lab/core/page-live-doc';

import { ManagedFolderClosedIcon } from '@confluence/smart-folder/entry-points/ManagedFolderClosedIcon.ts';
import { ManagedFolderOpenIcon } from '@confluence/smart-folder/entry-points/ManagedFolderOpenIcon.ts';
import { isSmartFolder } from '@confluence/smart-folder/entry-points/isSmartFolder.ts';

import type { ContentTreeTypes } from './contentTreeTypes.ts';

export type ContentTreeIconSpacing = 'none' | 'spacious';
type IconComponent = (props: any) => JSX.Element;

// Remove this component once these icons become available in atlaskit
export const ContentTreeIcon = ({
	label,
	color, // can override default icon color
	spacing,
	type,
	subType,
	isExpanded = false,
}: {
	label: string;
	color?: string;
	spacing?: ContentTreeIconSpacing;
	type: ContentTreeTypes;
	subType?: string | null;
	isExpanded?: boolean;
}): React.FunctionComponentElement<any> => {
	const contentTreeIconTypes: Record<ContentTreeTypes, IconComponent> = {
		page: PageIcon,
		whiteboard: WhiteboardIcon,
		slide: AiGenerativeSlidesIcon,
		database: DatabaseIcon,
		folder: isExpanded ? FolderOpenIcon : FolderClosedIcon,
		liveDoc: PageLiveDocIcon,
	};

	const icon = contentTreeIconTypes[type];
	const isManagedFolder = isSmartFolder({ type, subType });
	const testIdType = isManagedFolder ? 'managed-folder' : type;
	const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${testIdType}${
		type === 'folder' && isExpanded ? '-open' : ''
	}`;

	if (isManagedFolder) {
		const ManagedFolderIcon = isExpanded ? ManagedFolderOpenIcon : ManagedFolderClosedIcon;
		return <ManagedFolderIcon label={label} color={color} size="small" testId={testId} />;
	}

	return React.createElement(icon, {
		spacing,
		label,
		color,
		testId,
	});
};
